import { KitchenOrderStatusType } from 'features/Order/@types/KitchenMonitoring'

export const nextKitchenStatus: Partial<Record<KitchenOrderStatusType, KitchenOrderStatusType>> = {
  INCOMING: 'PROCESSING',
  PROCESSING: 'READY_TO_CHECK',
}

export const canTransitionKitchenOrder = (
  source: KitchenOrderStatusType,
  target: KitchenOrderStatusType,
) => nextKitchenStatus[source] === target
